export const REQUEST_HOSPITAL_LIST_BY_SERVICE =
  "REQUEST_HOSPITAL_LIST_BY_SERVICE";
export const REQUEST_HOSPITAL_LIST_BY_SERVICE_SUCCESS =
  "REQUEST_HOSPITAL_LIST_BY_SERVICE_SUCCESS";
export const REQUEST_HOSPITAL_LIST_BY_SERVICE_FAIL =
  "REQUEST_HOSPITAL_LIST_BY_SERVICE_FAIL";
export const SELECTED_CHOOSE_HOSPITAL_LIST_BY_SERVICE =
  "SELECTED_CHOOSE_HOSPITAL_LIST_BY_SERVICE";
export const TOGGLE_MODAL_CHOOSE_HOSPITAL_BY_SERVICE =
  "TOGGLE_MODAL_CHOOSE_HOSPITAL_BY_SERVICE";
export const RESET_MODAL_CHOOSE_HOSPITAL_BY_SERVICE =
  "RESET_MODAL_CHOOSE_HOSPITAL_BY_SERVICE";
/* ################ */

export const HOSPITAL_LIST_REQUEST = "HOSPITAL_LIST_REQUEST";
export const HOSPITAL_LIST_REQUEST_SUCCESS = "HOSPITAL_LIST_REQUEST_SUCCESS";
export const HOSPITAL_LIST_REQUEST_FAIL = "HOSPITAL_LIST_REQUEST_FAIL";

export const URL_REQUEST_HOSPITAL_LIST = "/hospital/getall";
// export const URL_REQUEST_HOSPITAL_LIST_BY_SERVICE = '/hospital/getbyfeature';
// export const URL_REQUEST_HOSPITAL_LIST_BY_SERVICE = "/hospital/getall";
